export default function (value) {
  if (value) {
    return value.toFixed(3);
  } else {
    return 0;
  }
}
